import React from 'react';

const VIDEOS = [
  {
    id: 1,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/Living_Media_Promo_mcavgb.mp4"
  },
  {
    id: 2,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/Living_media_vacuum_dhyixh.mp4"
  },
  {
    id: 3,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/living_media_-_dancing_zl9cru.mp4"
  },
  {
    id: 4,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/LivingMedia_BTS_fnejyr.mp4"
  },
  {
    id: 5,
    url: "https://res.cloudinary.com/digw3ykex/video/upload/q_auto,vc_auto/v1/Living_Media_Coffee_vc2hmh.mp4"
  }
];

const DesktopHeroAnimation = () => {
  return (
    <div 
      className="desktop-hero-container hidden lg:block absolute inset-0 overflow-hidden pointer-events-none z-0"
      aria-hidden="true"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/90 via-40% to-transparent z-10" />
      
      <div className="relative w-full h-full top-[25%] perspective-1000">
        {VIDEOS.map((item, index) => {
          // Updated delay calculation for 30s duration (30/5 = 6s spacing)
          const delay = (index * -6) + 's';
          const isFirst = index === 0;
          
          return (
            <div
              key={item.id}
              className="absolute left-0 w-[320px] aspect-[9/19.5] animate-desktop-carousel"
              style={{ 
                animationDelay: delay,
                willChange: 'transform',
                contentVisibility: 'auto',
                containIntrinsicSize: '320px 693px'
              }}
            >
              <div className="relative w-full h-full bg-[#0a0a0a] rounded-[2.5rem] shadow-2xl ring-1 ring-white/20 overflow-hidden">
                <div className="absolute inset-[4px] rounded-[2.2rem] overflow-hidden bg-black">
                  <div className="w-full h-full relative pointer-events-none bg-black overflow-hidden">
                    <div className="absolute inset-0 z-50 bg-transparent" />
                    
                    {/* Full-size Wrapper for Video */}
                    <div className="absolute top-0 left-0 w-full h-full overflow-hidden bg-black">
                      {/* Native HTML5 Video */}
                      <video
                        src={item.url}
                        className="absolute top-1/2 left-1/2 w-full h-full object-cover"
                        style={{ 
                          transform: 'translate(-50%, -50%)',
                          border: 'none'
                        }}
                        autoPlay={true}
                        loop
                        muted
                        playsInline
                        webkit-playsinline="true"
                        preload={isFirst ? "auto" : "none"}
                        poster={`https://res.cloudinary.com/digw3ykex/video/upload/so_0,f_jpg,q_auto/v1/${item.url.split('/').pop().replace('.mp4', '')}.jpg`}
                      />
                    </div>
                  </div>

                  {/* Dynamic Island */}
                  <div className="absolute top-4 left-1/2 -translate-x-1/2 w-[30%] h-7 bg-black rounded-full z-20 flex items-center justify-center gap-2 shadow-sm">
                    <div className="w-2 h-2 rounded-full bg-[#1a1a1a]" />
                    <div className="w-1.5 h-1.5 rounded-full bg-[#111]" />
                  </div>

                  {/* Reflection */}
                  <div className="absolute inset-0 bg-gradient-to-tr from-white/10 via-transparent to-white/5 pointer-events-none mix-blend-overlay" />
                </div>

                {/* Frame - Updated to Desaturated Muted Olive Green (#5C6B46) */}
                <div className="absolute inset-0 rounded-[2.5rem] border-[4px] border-[#5C6B46] pointer-events-none" />
                
                {/* Highlight */}
                <div className="absolute top-0 right-0 w-full h-full rounded-[2.5rem] border-t border-r border-white/10 opacity-50 pointer-events-none" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DesktopHeroAnimation;